const team_data = [
  {
    id: "0Founder and CEO",
    image: "/images/team/team_1.jpg",
    title: "Founder and CEO",
    name: "Noleen Mariappen",
    link: "https://www.linkedin.com/in/noleenm/",
  },
  {
    id: "1Editor, TechRenews Newsletter",
    image: "/images/team/team_2.jpg",
    title: "Editor, TechRenews Newsletter",
    name: "Kala Philo",
    link: "https://www.linkedin.com/in/kalaphilo/",
  },
  {
    id: "2Founder, Optimal Tech",
    image: "/images/team/team_3.jpg",
    title: "Founder, Optimal Tech",
    name: "Dr. Reginald Parker",
    link: "https://www.linkedin.com/in/drparker/",
  },
  {
    id: "3Founder and CEO, Aunua Global",
    image: "/images/team/team_4.jpg",
    title: "Founder and CEO, Aunua Global",
    name: "Karina Murray",
    link: "https://www.linkedin.com/in/karina-murray-169361161/",
  },
  {
    id: "4CEO, Digital Mind State",
    image: "/images/team/team_5.jpg",
    title: "CEO, Digital Mind State",
    name: "Mike Johns",
    link: "https://www.linkedin.com/in/mikejohns/",
  },
  {
    id: "5Fintech Founder and Advisor",
    image: "/images/team/team_6.jpg",
    title: "Fintech Founder and Advisor",
    name: "Dr. Ritesh Jain",
    link: "https://www.linkedin.com/in/drriteshjain/",
  },
  {
    id: "6Deep Tech Influencer",
    image: "/images/team/team_7.jpg",
    title: "Deep Tech Influencer",
    name: "Dr. Ingrid Vasiliu Feltes",
    link: "https://www.linkedin.com/in/ingrid-vasiliu-feltes-mdmba/",
  },
  {
    id: "7EMEA Regional Director, GBA",
    image: "/images/team/team_8.jpg",
    title: "EMEA Regional Director, GBA",
    name: "Priya Guliani",
    link: "https://www.linkedin.com/in/priyaguliani/",
  },
  {
    id: "8Sustainability and ESG Director",
    image: "/images/team/team_9.jpg",
    title: "Sustainability and ESG Director",
    name: "Jeffrey Eades",
    link: "https://www.linkedin.com/in/jeffrey-e-a9074332/",
  },
  {
    id: "8International Publicist",
    image: "/images/team/team_10.jpg",
    title: "International Publicist",
    name: "Kerrin Black",
    link: "https://www.linkedin.com/in/kerrinblack/",
  },
  {
    id: "8Practicing Lawyer",
    image: "/images/team/team_12.jpg",
    title: "Practicing Lawyer",
    name: "Laura Clatworthy",
    link: "https://www.linkedin.com/in/laura-clatworthy-4b589421/",
  },
];

export { team_data };
